export default __webpack_public_path__ + "static/media/asking_person.dc85100d.png";